import { useEffect, useCallback } from 'react'
import { useDispatch, useSelector, shallowEqual } from 'react-redux'
import {
    RPM_UPDATE_USER_INSURANCE_INFORMATION_BEGIN,
    RPM_UPDATE_USER_INSURANCE_INFORMATION_SUCCESS,
    RPM_UPDATE_USER_INSURANCE_INFORMATION_FAILURE,
    RPM_UPDATE_USER_INSURANCE_INFORMATION_DISMISS_ERROR,
} from './constants'
import axios from 'axios'
import config from '../../../common/config'
import { createAxiosConfigWithAuth } from '../../../common/apiHelpers'

export function updateUserInsuranceInformation(args = {}) {
    return (dispatch, getState) => {
        // optionally you can have getState as the second argument
        dispatch({
            type: RPM_UPDATE_USER_INSURANCE_INFORMATION_BEGIN,
        })

        const promise = new Promise((resolve, reject) => {
            const fetchMethod = args.method === 'POST' ? axios.post : axios.put
            const doRequest = fetchMethod(
                `${config.apiRootUrl}/users/${args.userId}/insurance-information`,
                args,
                {
                    ...createAxiosConfigWithAuth(getState()),
                }
            )
            doRequest.then(
                res => {
                    dispatch({
                        type: RPM_UPDATE_USER_INSURANCE_INFORMATION_SUCCESS,
                        data: res,
                    })
                    resolve(res)
                },
                // Use rejectHandler as the second argument so that render errors won't be caught.
                err => {
                    dispatch({
                        type: RPM_UPDATE_USER_INSURANCE_INFORMATION_FAILURE,
                        data: { error: err },
                    })
                    reject(err)
                }
            )
        })

        return promise
    }
}

export function dismissUpdateUserInsuranceInformationError() {
    return {
        type: RPM_UPDATE_USER_INSURANCE_INFORMATION_DISMISS_ERROR,
    }
}

export function useUpdateUserInsuranceInformation() {
    const dispatch = useDispatch()

    const {
        updateUserInsuranceInformationPending,
        updateUserInsuranceInformationError,
    } = useSelector(
        state => ({
            updateUserInsuranceInformationPending:
                state.rpm.updateUserInsuranceInformationPending,
            updateUserInsuranceInformationError:
                state.rpm.updateUserInsuranceInformationError,
        }),
        shallowEqual
    )

    const boundAction = useCallback(
        (...args) => {
            return dispatch(updateUserInsuranceInformation(...args))
        },
        [dispatch]
    )

    const boundDismissError = useCallback(() => {
        return dispatch(dismissUpdateUserInsuranceInformationError())
    }, [dispatch])

    return {
        updateUserInsuranceInformation: boundAction,
        updateUserInsuranceInformationPending,
        updateUserInsuranceInformationError,
        dismissUpdateUserInsuranceInformationError: boundDismissError,
    }
}

export function reducer(state, action) {
    switch (action.type) {
        case RPM_UPDATE_USER_INSURANCE_INFORMATION_BEGIN:
            // Just after a request is sent
            return {
                ...state,
                updateUserInsuranceInformationPending: true,
                updateUserInsuranceInformationError: null,
            }

        case RPM_UPDATE_USER_INSURANCE_INFORMATION_SUCCESS:
            // The request is success
            return {
                ...state,
                updateUserInsuranceInformationPending: false,
                updateUserInsuranceInformationError: null,
            }

        case RPM_UPDATE_USER_INSURANCE_INFORMATION_FAILURE:
            // The request is failed
            return {
                ...state,
                updateUserInsuranceInformationPending: false,
                updateUserInsuranceInformationError: action.data.error,
            }

        case RPM_UPDATE_USER_INSURANCE_INFORMATION_DISMISS_ERROR:
            // Dismiss the request failure error
            return {
                ...state,
                updateUserInsuranceInformationError: null,
            }

        default:
            return state
    }
}
